import {
  API_URL,
  v,
  put,
  debug,
  request,
  takeEvery,
  createDoRequestAction,
  assertTotalSchema,
  SagaIterator,
  call,
} from '../../lib'

import {doREQUEST_ERROR, doREQUEST_COMPLETE, doBATCH_PARTICIPANT_CREDENTIALS_UPDATE} from '../state'
import {getToken} from './token_fetcher'

export const REQUEST_PARTICIPANT_CREDENTIALS_REGENERATE = 'REQUEST_PARTICIPANT_CREDENTIALS_REGENERATE'
export const doREQUEST_PARTICIPANT_CREDENTIALS_REGENERATE = createDoRequestAction(
  REQUEST_PARTICIPANT_CREDENTIALS_REGENERATE,
)

export const requestParticipantCredentialsRegenerateActionCreators = {
  doREQUEST_PARTICIPANT_CREDENTIALS_REGENERATE,
}

export function* requestParticipantCredentialsRegenerate({payload, setRequestResult}: any): SagaIterator {
  debug('saga*requestParticipantCredentialsRegenerate')

  try {
    assertTotalSchema({
      payload,
      schema: v.object({
        requestId: v.string().uuid().exist(),
        participantId: v.string().uuid().exist(),
      }),
    })
  } catch (error) {
    return yield put(
      doREQUEST_ERROR(
        {
          fromType: REQUEST_PARTICIPANT_CREDENTIALS_REGENERATE,
          requestId: payload.requestId,
          error,
        },
        setRequestResult,
      ),
    )
  }

  const {participantId} = payload

  const accessToken = yield call(getToken)

  const result = yield request({
    method: 'post',
    url: `${API_URL}/v1/web/participant-credentials-regenerate`,
    accessToken,
    data: {
      participantId,
    },
  })

  if (!result.success || result.error) {
    const error = result.error || new Error('request did not succeed')
    debug(error)
    return yield put(
      doREQUEST_ERROR(
        {
          fromType: REQUEST_PARTICIPANT_CREDENTIALS_REGENERATE,
          fromPayload: payload,
          requestId: payload.requestId,
          url: '/v1/web/participant-credentials-regenerate',
          ...result,
          error,
        },
        setRequestResult,
      ),
    )
  }

  yield put(
    doBATCH_PARTICIPANT_CREDENTIALS_UPDATE({
      batchId: result.payload.batchId,
      participantId: result.payload.id,
      credentials: result.payload.credentials,
    }),
  )

  yield put(
    doREQUEST_COMPLETE(
      {
        fromType: REQUEST_PARTICIPANT_CREDENTIALS_REGENERATE,
        requestId: payload.requestId,
        ...result,
      },
      setRequestResult,
    ),
  )
}

export function* participantCredentialsRegenerateSaga() {
  yield takeEvery(REQUEST_PARTICIPANT_CREDENTIALS_REGENERATE as any, requestParticipantCredentialsRegenerate)
}
